import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IPortalNoteModel } from '@apps-common/types/portal/portal-note'

export const updatePortalNote = async (model: IPortalNoteModel, image?: any): Promise<IPortalNoteModel> =>
  new Promise((resolve, reject) => {
    axios
      .post(`/portalnotes/updatenote`, model)
      .then((res) => {
        if (image) {
          const fileData = new FormData()

          fileData.append('file', image?.blob || image)

          axios
            .post(`/portalnotes/uploadimg?noteId=${res?.data?.data?.portalNoteId}`, fileData)
            .then((imageRes) => resolve(imageRes?.data?.data))
            .catch((err) => reject(err))
        } else {
          resolve(res?.data?.data)
        }
      })
      .catch((err) => reject(err))
  })

type Props = {
  model: IPortalNoteModel
  image?: any
}

export const useUpdatePortalNote = (notify?: boolean, onSuccess?: (data: IPortalNoteModel) => void) =>
  useMutation({
    mutationKey: ['updatePortalNote'],
    mutationFn: ({ model, image }: Props) => updatePortalNote(model, image),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated note.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update note, please try again.')
      }
    },
    throwOnError: false
  })
